import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import { FormCheckbox } from "~/components/ModalObjects";
import { editTask } from "~/store/actions/actions.tasks.jsx";
import { getTaskByIdObject } from "~/store/selectors/selector.tasks.jsx";
import { getCanLoggedUserChangeBillableStatus } from "~/store/selectors/selector.tracking.jsx";

export const TaskBillableStatus = ({ defaultChecked, onChange, className }) => {
  const [checked, setChecked] = useState(defaultChecked);

  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    const value = !checked;
    setChecked(value);
    if (typeof onChange === `function`) {
      onChange(value);
    }
  }, [checked, onChange]);

  return (
    <div className={classnames("tw-flex tw-flex-row", className)}>
      <FormCheckbox
        id="task_is_billable"
        checked={checked}
        onChange={handleClick}
        text={t("Task is billable")}
      />
    </div>
  );
};

TaskBillableStatus.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
};

TaskBillableStatus.defaultProps = {
  defaultChecked: false,
};

TaskBillableStatus.displayName = "TaskBillableStatus";

const TaskBillableStatusContainer = ({ taskId, projectId, ...rest }) => {
  const dispatch = useDispatch();
  const task = useSelector((state) => getTaskByIdObject(state, taskId));
  const handleChange = useCallback(
    (value) => {
      dispatch(editTask(projectId, taskId, { is_billable: value }));
    },
    [projectId, taskId, dispatch]
  );
  const canSeeBillable = useSelector((state) => getCanLoggedUserChangeBillableStatus(state, { projectId }));

  return canSeeBillable ? (
    <TaskBillableStatus
      {...rest}
      defaultChecked={task.is_billable}
      onChange={handleChange}
    />
  ) : null;
};

TaskBillableStatusContainer.propTypes = {
  taskId: PropTypes.number,
  projectId: PropTypes.number,
};

export default TaskBillableStatusContainer;
